import { submitCaptcha } from "./captcha"
import config from "../config"
const base_url = config.base_url
export const sendUIErrorToBackend = (error) =>{
    submitCaptcha()
      .then(token=>{
        fetch(base_url + "error/handle", {
            method: "POST",
            mode: "cors",
            headers: {
              Accept: "application/json, text/plain, */*",
              "Content-type": "application/x-www-form-urlencoded",
              credentials: "include",
            },
            credentials: "include",
            body:`token=${token}&location=${window?.location?.href}&error=${error}&errorInfo=${error?.stack})}`
          })
      })
}